import React from 'react';
import { Item, Segment, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import moment from 'moment'

const RewardsList = (props) => {
    return (
        <div>
            <div style={{fontSize: 22, fontWeight: 700, marginBottom: "10px"}}>{props.categoryName}</div>
                    <div>Offered by Rewardz</div>
        <Item.Group divided>
            {
                _.map(props.rewards, (reward) => {
                    const {
                        pk,
                        thumbnailURL,
                        name,
                        excerpt,
                        valid_until
                    } = reward;
                    return (
                        <Item key={pk}>
                            <Item.Image src={thumbnailURL} />
                            <Item.Content>
                                <Item.Header>
                                    <Link to={`/app/rewards/${props.category}/details/${pk}`}>
                                        {name}
                                    </Link>
                                </Item.Header>
                                <Item.Description>
                                    {excerpt}
                                </Item.Description>
                                <Item.Description>
                                    {"Valid until " + moment(valid_until).format('DD MMM YYYY hh:mm A') + ""}
                                </Item.Description>
                            </Item.Content>
                        </Item>
                    );
                })
            }
        </Item.Group>
        <div style={{marginBottom: "10px"}}/>
        </div>
    );
}

export default RewardsList;
